import React, { useState } from "react";
import { FontAwesomeIcon }
    from "@fortawesome/react-fontawesome";

import {
    faEye
}
    from "@fortawesome/free-solid-svg-icons";
	
import ScrollableList from "../../../components/ScrollableList";

export default function RoomAreaList({
    rows,
    selectedRoomId,
    onSelect,
	selectedSpaceTypeId
})
{
	
	const [searchText, setSearchText] =
	    useState("");
	
	
    if(!rows || rows.length === 0)
    {
        return null;
    }

    let maxCapacity = 0;

    for(let i = 0; i < rows.length; i++)
    {
        if(rows[i].capacity > maxCapacity)
        {
            maxCapacity =
                rows[i].capacity;
        }
    }
	
	
	const filteredRows =
	    rows.filter(
	        function(row)
	        {
				
	            const matchesSearch =
	                row.name
	                    .toLowerCase()
	                    .includes(
	                        searchText.toLowerCase()
	                    );

	            const matchesSpaceType =
	                !selectedSpaceTypeId ||
	                selectedSpaceTypeId === -100 ||
	                row.spaceTypeId ===
	                    selectedSpaceTypeId;

	            return (
	                matchesSearch &&
	                matchesSpaceType
	            );
	        }
	    );

    return (
        <div>
		<div
		    style={{
		        marginBottom: "12px",
				paddingBottom:'12px'
		    }}
		>

		    <input
		        type="text"
		        placeholder="Search rooms..."
		        value={searchText}
		        onChange={function(event)
		        {
		            setSearchText(
		                event.target.value
		            );
		        }}
		        style={{
		            width: "100%",
		            height: "32px",

		            border: "1px solid rgba(255,255,255,0.15)",
		            borderRadius: "8px",

		            background:
		                "rgba(255,255,255,0.08)",

		            color: "#ffffff",

		            paddingLeft: "10px",
		            paddingRight: "10px",

		            outline: "none",

		            fontSize: "11px",

		            boxSizing: "border-box"
		        }}
		    />

		</div>
		<ScrollableList>
            {
                filteredRows.map(
                    function(row)
                    {
                        const widthPercent =
                            row.capacity /
                            maxCapacity *
                            100;

                        const isSelected =
                            selectedRoomId === row.id;

                        return (
                            <div
                                key={row.id}
                                style={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "10px",
                                    marginBottom: "6px",
                                    padding: "4px 6px",
                                    borderRadius: "6px",

                                    background:
                                        isSelected
                                            ? "rgba(255,255,255,0.10)"
                                            : "transparent",

                                    border:
                                        isSelected
                                            ? "1px solid rgba(255,255,255,0.15)"
                                            : "1px solid transparent",

                                    transition:
                                        "all 0.2s ease"
                                }}
                            >

                                <FontAwesomeIcon
                                    icon={faEye}
                                    style={{
                                        color: "#ffffff",
                                        opacity: 0.7,
                                        cursor: "pointer",
                                        width: "14px"
                                    }}
									onClick={
									    function()
									    {
									        if(!onSelect)
									        {
									            return;
									        }

									        if(selectedRoomId === row.id)
									        {
									            onSelect(
									            {
									                id: null
									            });
									        }
									        else
									        {
									            onSelect(
									                row);
									        }
									    }
									}
                                />

                                <div
                                    style={{
                                        width: "120px",
                                        color: "#ffffff",
                                        fontSize: "11px",
                                        overflow: "hidden",
                                        textOverflow: "ellipsis",
                                        whiteSpace: "nowrap"
                                    }}
                                >
                                    {row.name}
                                </div>

                                <div
                                    style={{
                                        flex: 1,
                                        height: "8px",
                                        borderRadius: "999px",
                                        overflow: "hidden",
                                        background:
                                            "linear-gradient(180deg,#2f3136,#1a1c20)",

                                        boxShadow:
                                            "inset 0 1px 2px rgba(255,255,255,0.08), inset 0 -1px 2px rgba(0,0,0,0.5)"
                                    }}
                                >
                                    <div
                                        style={{
                                            width:
                                                widthPercent + "%",

                                            height: "100%",

                                            background:
                                                row.color,
												
												borderRadius:'50px'
                                        }}
                                    />
                                </div>

                                <div
                                    style={{
                                        width: "55px",
                                        textAlign: "right",
                                        color: "#ffffff",
                                        fontSize: "11px"
                                    }}
                                >
                                    {row.capacity}
                                </div>

                            </div>
                        );
                    }
                )
            }
			</ScrollableList>
        </div>
    );
}